/*
 *   Copyright (c) 2021 Novumare Technologies
 *   All rights reserved.
 */
/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
import imgTanker from '../assets/img/tankership.jpg';
import imgLogin from 'assets/img/login.jpg'
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";
import { useTranslation } from 'react-i18next';
// İmage import 
import btnComponent from 'assets/img/component-btn.png';
import profileCardComponent from 'assets/img/component-profile-card.png';
import infoComponent from 'assets/img/component-info-card.png';
import infoComponent2 from 'assets/img/component-info-2.png';
import menuComponent from 'assets/img/component-menu.png';
import btnPinkComponent from 'assets/img/component-btn-pink.png';
import docImage from 'assets/img/documentation.png';
import profileImage from 'assets/img/profile.jpg';


export default function Index() {
  const { t } = useTranslation();
  return (
    <>
      <IndexNavbar fixed />
      <section className="header relative pt-16 items-center flex h-screen max-h-860-px">
        <div className="container mx-auto items-center flex flex-wrap">
          <div className="w-full md:w-8/12 lg:w-6/12 xl:w-6/12 px-4">
            <div className="pt-32 sm:pt-0">
              <h2 className="font-semibold text-4xl text-gray-700">
                {t('lets-solve-boiler-problem-nextgen')}
              </h2>
              <p className="mt-4 text-lg leading-relaxed text-gray-600">
                {t('lets-solve-boiler-problem-nextgen-p')}
              </p>
              <div className="mt-12">
                <Link
                  to="/admin/dashboard"
                  className="get-started text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-blue-500 active:bg-blue-600  text-sm shadow hover:shadow-lg ease-linear transition-all duration-150"
                >
                  {t('dashboard')}
                </Link>
                <a
                  href="#features"
                  className="github-star ml-1 text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-gray-800 active:bg-gray-700  text-sm shadow hover:shadow-lg ease-linear transition-all duration-150"
                >
                  {t('features')}
                </a>
              </div>
            </div>
          </div>
        </div>

        <img
          className="absolute top-0 b-auto right-0 hidden lg:block pt-16  sm:w-6/12 -mt-48 sm:mt-0 w-10/12 max-h-860px "
          src={imgTanker}
          alt="..."
        />
      </section>

      <section id="features" className="mt-48 md:mt-40 pb-40 relative bg-gray-200">
        <div
          className="-mt-20 top-0 bottom-auto left-0 right-0 w-full absolute h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-gray-200 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
        <div className="container mx-auto">
          <div className="flex flex-wrap items-center">
            <div className="w-10/12 md:w-6/12 lg:w-4/12 px-12 md:px-4 mr-auto ml-auto -mt-32">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-blue-600">
                <img
                  alt="..."
                  src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=80"
                  className="w-full align-middle rounded-t-lg"
                />
                <blockquote className="relative p-8 mb-4">
                  <svg
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 583 95"
                    className="absolute left-0 w-full block h-95-px -top-94-px"
                  >
                    <polygon
                      points="-30,95 583,95 583,65"
                      className="text-blue-600 fill-current"
                    ></polygon>
                  </svg>
                  <h4 className="text-xl font-bold text-white">
                    {t('landing-executed-autonomously-all-process')}
                  </h4>
                  <p className="text-md font-light mt-2 text-white">
                    {t('landing-executed-autonomously-all-process-p')}
                  </p>
                </blockquote>
              </div>
            </div>

            <div className="w-full md:w-6/12 px-4">
              <div className="flex flex-wrap">
                <div className="w-full md:w-6/12 px-4">
                  <div className="relative flex flex-col mt-4">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-gray-600 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                        <i className="fas fa-chart-bar"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">
                        {t('landing-analysis')}
                      </h6>
                      <p className="mb-4 text-gray-600">
                        {t('landing-analysis-p')}
                      </p>
                    </div>
                  </div>
                  <div className="relative flex flex-col min-w-0">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-gray-600 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                        <i className="fas fa-drafting-compass"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">
                        {t('landing-allinone-fleet-status')}
                      </h6>
                      <p className="mb-4 text-gray-600">
                        {t('landing-allinone-fleet-status-p')}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-6/12 px-4">
                  <div className="relative flex flex-col min-w-0 mt-4">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-gray-600 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                        <i className="fas fa-flask"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">{t('landing-dosage')}</h6>
                      <p className="mb-4 text-gray-600">
                        {t('landing-dosage-p')}
                      </p>
                    </div>
                  </div>
                  <div className="relative flex flex-col min-w-0">
                    <div className="px-4 py-5 flex-auto">
                      <div className="text-gray-600 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-white">
                        <i className="fas fa-file-alt"></i>
                      </div>
                      <h6 className="text-xl mb-1 font-semibold">
                        {t('landing-inventory')}
                      </h6>
                      <p className="mb-4 text-gray-600">
                        {t('landing-inventory-p')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mx-auto overflow-hidden pb-20">
          <div className="flex flex-wrap items-center">
            <div className="w-full md:w-4/12 px-12 md:px-4 ml-auto mr-auto mt-48">
              <div className="text-gray-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                <i className="fas fa-chart-bar text-xl"></i>
              </div>
              <h3 className="text-3xl mb-2 font-semibold leading-normal">
                {t('landing-analysis')}
              </h3>
              <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-gray-700">
                {t('landing-analysis-p-2')}
              </p>
              <div className="block pb-6">
                <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                  pH
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                  {t('elec-cond')}
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                  {t('tds')}
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                  {t('do')}
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                  {t('orp')}
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                  {t('temp')}
                </span>
              </div>
            </div>

            <div className="w-full md:w-5/12 px-4 mr-auto ml-auto mt-32">
              <div className="relative flex flex-col min-w-0 w-full mb-6 mt-48 md:mt-0">
                <img
                  alt="..."
                  src={btnComponent}
                  className="w-full align-middle rounded absolute shadow-lg max-w-100-px z-3 left-145-px -top-29-px"
                />
                <img
                  alt="..."
                  src={profileCardComponent}
                  className="w-full align-middle rounded-lg absolute shadow-lg -top-160-px left-260-px max-w-210-px"
                />
                <img
                  alt="..."
                  src={infoComponent}
                  className="w-full align-middle rounded-lg absolute shadow-lg max-w-180-px -top-225-px left-40-px z-2"
                />
                <img
                  alt="..."
                  src={infoComponent2}
                  className="w-full align-middle rounded-lg absolute shadow-2xl max-w-200-px -left-50-px top-25-px"
                />
                <img
                  alt="..."
                  src={menuComponent}
                  className="w-full align-middle rounded absolute shadow-lg max-w-580-px -left-20-px top-210-px"
                />
                <img
                  alt="..."
                  src={btnPinkComponent}
                  className="w-full align-middle rounded absolute shadow-xl max-w-120-px left-195-px top-95-px"
                />
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center pt-32">
            <div className="w-full md:w-6/12 px-4 mr-auto ml-auto mt-32">
              <div className="justify-center flex flex-wrap relative">
                <div className="my-4 w-full lg:w-6/12 px-4">
                  <a
                    href="https://www.creative-tim.com/learning-lab/tailwind/svelte/alerts/notus?ref=vtw-index"
                    target="_blank"
                  >
                    <div className="bg-red-600 shadow-lg rounded-lg text-center p-8">
                      <img
                        alt="..."
                        className="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
                        src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/svelte.jpg"
                      />
                      <p className="text-lg text-white mt-4 font-semibold">
                        Svelte
                      </p>
                    </div>
                  </a>
                  <a
                    href="https://www.creative-tim.com/learning-lab/tailwind/react/alerts/notus?ref=vtw-index"
                    target="_blank"
                  >
                    <div className="bg-blue-500 shadow-lg rounded-lg text-center p-8 mt-8">
                      <img
                        alt="..."
                        className="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
                        src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/react.jpg"
                      />
                      <p className="text-lg text-white mt-4 font-semibold">
                        ReactJS
                      </p>
                    </div>
                  </a>
                  <a
                    href="https://www.creative-tim.com/learning-lab/tailwind/nextjs/alerts/notus?ref=vtw-index"
                    target="_blank"
                  >
                    <div className="bg-gray-800 shadow-lg rounded-lg text-center p-8 mt-8">
                      <img
                        alt="..."
                        className="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
                        src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/nextjs.jpg"
                      />
                      <p className="text-lg text-white mt-4 font-semibold">
                        NextJS
                      </p>
                    </div>
                  </a>
                </div>
                <div className="my-4 w-full lg:w-6/12 px-4 lg:mt-16">
                  <a
                    href="https://www.creative-tim.com/learning-lab/tailwind/js/alerts/notus?ref=vtw-index"
                    target="_blank"
                  >
                    <div className="bg-yellow-500 shadow-lg rounded-lg text-center p-8">
                      <img
                        alt="..."
                        className="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
                        src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/js.png"
                      />
                      <p className="text-lg text-white mt-4 font-semibold">
                        JavaScript
                      </p>
                    </div>
                  </a>
                  <a
                    href="https://www.creative-tim.com/learning-lab/tailwind/angular/alerts/notus?ref=vtw-index"
                    target="_blank"
                  >
                    <div className="bg-red-700 shadow-lg rounded-lg text-center p-8 mt-8">
                      <img
                        alt="..."
                        className="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
                        src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/angular.jpg"
                      />
                      <p className="text-lg text-white mt-4 font-semibold">
                        Angular
                      </p>
                    </div>
                  </a>
                  <a
                    href="https://www.creative-tim.com/learning-lab/tailwind/vue/alerts/notus?ref=vtw-index"
                    target="_blank"
                  >
                    <div className="bg-green-500 shadow-lg rounded-lg text-center p-8 mt-8">
                      <img
                        alt="..."
                        className="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
                        src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/vue.jpg"
                      />
                      <p className="text-lg text-white mt-4 font-semibold">
                        Vue.js
                      </p>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div className="w-full md:w-4/12 px-12 md:px-4 ml-auto mr-auto mt-48">
              <div className="text-gray-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                <i className="fas fa-flask text-xl"></i>
              </div>
              <h3 className="text-3xl mb-2 font-semibold leading-normal">
                {t('landing-dosaging')}
              </h3>
              <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-gray-700">
                {t('landing-dosaging-p')}
              </p>
              <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-gray-700">
                {t('landing-dosaging-p-2')}
              </p>
              <div className="block pb-6">
                <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                  {t('landing-boiler-water-treatment-chemicals')}
                </span>
                <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                  {t('landing-other-chemicals')}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="container mx-auto px-4 pb-32 pt-48">
          <div className="items-center flex flex-wrap">
            <div className="w-full md:w-5/12 ml-auto px-12 md:px-4">
              <div className="md:pr-12">
                <div className="text-gray-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                  <i className="fas fa-brain text-xl"></i>
                </div>
                <h3 className="text-3xl font-semibold">
                  {t('landing-powered-by-ai')}
                </h3>
                <p className="mt-4 text-lg leading-relaxed text-gray-600">
                  {t('landing-powered-by-ai-p')}
                </p>
                <ul className="list-none mt-6">
                  <li className="py-2">
                    <div className="flex items-center">
                      <div>
                        <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-gray-100 mr-3">
                          <i className="fas fa-fingerprint"></i>
                        </span>
                      </div>
                      <div>
                        <h4 className="text-gray-600">
                          {t('landing-prediction-your-next-dosaging')}
                        </h4>
                      </div>
                    </div>
                  </li>
                  <li className="py-2">
                    <div className="flex items-center">
                      <div>
                        <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-gray-100 mr-3">
                          <i className="fab fa-html5"></i>
                        </span>
                      </div>
                      <div>
                        <h4 className="text-gray-600">
                          {t('landing-competitive-results-in-the-fleet')}
                        </h4>
                      </div>
                    </div>
                  </li>
                  <li className="py-2">
                    <div className="flex items-center">
                      <div>
                        <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-gray-100 mr-3">
                          <i className="far fa-paper-plane"></i>
                        </span>
                      </div>
                      <div>
                        <h4 className="text-gray-600">
                          {t('landing-show-your-H2OScore-and-share-with-the-fleet')}
                        </h4>
                      </div>
                    </div>
                  </li>
                </ul><br></br>
                <div className="block pb-6">
                  <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                    {t('landing-fleet-status')}
                  </span>
                  <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                    {t('landing-live-fleet-report')}
                  </span>
                  <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                    {t('perf-score')}
                  </span>
                  <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                    {t('landing-treat-ai')}
                  </span>
                  <span className="text-xs font-semibold inline-block py-1 px-2  rounded-full text-gray-600 bg-white  last:mr-0 mr-2 mt-2">
                    {t('landing-dosage-predicts')}
                  </span>
                </div>
              </div>
            </div>

            <div className="w-full md:w-6/12 mr-auto px-4 pt-24 md:pt-0">
              <img
                alt="..."
                className="max-w-full rounded-lg shadow-xl"
                style={{
                  transform:
                    "scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg)",
                }}
                src={docImage}
              />
            </div>
          </div>
        </div>

        <div className="justify-center text-center flex flex-wrap mt-24">
          <div className="w-full md:w-6/12 px-12 md:px-4">
            <h2 className="font-semibold text-4xl">{t('landing-tailor-made-applications')}</h2>
            <p className="text-lg leading-relaxed mt-4 mb-4 text-gray-600">
              {t('landing-tailor-made-applications-p')}
            </p>
          </div>
        </div>
      </section>

      <section className="block relative z-1 bg-gray-700">
        <div className="container mx-auto">
          <div className="justify-center flex flex-wrap">
            <div className="w-full lg:w-12/12 px-4  -mt-24">
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4 flex-1  md:flex-none">
                  <h5 className="text-xl font-semibold pb-4 text-center">
                    {t('landing-web-application')}
                  </h5>
                  <Link to="/auth/login">
                    <div className="hover:-mt-4 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150">
                      <img
                        alt="..."
                        className="align-middle border-none max-w-full h-auto rounded-lg"
                        src={imgLogin}
                      />
                    </div>
                  </Link>
                </div>

                <div className="w-full lg:w-6/12 px-4 flex-1  md:flex-none">
                  <h5 className="text-xl font-semibold pb-4 text-center">
                    {t('landing-mobile-application')}

                  </h5>
                  <Link to="/profile">
                    <div className="hover:-mt-4 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150">
                      <img
                        alt="..."
                        className="align-middle border-none max-w-full h-auto rounded-lg"
                        src={profileImage}
                      />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-700 overflow-hidden">
        <div className="container mx-auto pb-64">
          <div className="flex flex-wrap justify-center">
            <div className="w-full md:w-5/12 px-12 md:px-4 ml-auto mr-auto md:mt-64">
              <div className="text-gray-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                <i className="fas fa-bezier-curve text-xl"></i>
              </div>
              <h3 className="text-3xl mb-2 font-semibold leading-normal text-white">
                {t('landing-limit-is-the-sky')}
              </h3>
              <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-gray-300">
                {t('landing-limit-is-the-sky-p')}
              </p>
              <p className="text-lg font-light leading-relaxed mt-0 mb-4 text-gray-300">
                {t('landing-limit-is-the-sky-p-2')}

              </p>
              <a
                // href="https://github.com/creativetimofficial/notus-react?ref=nr-index"
                // target="_blank"
                className="github-star mt-4 inline-block text-white cursor-pointer font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-gray-800 active:bg-gray-700  text-sm shadow hover:shadow-lg"
                onClick={() => void (Tawk_API.maximize())}
              >
                {t('contact-us')}
              </a>
            </div>

            <div className="w-full md:w-4/12 px-4 mr-auto ml-auto mt-32 relative">
              <i className="fas fa-hands-helping text-gray-800 absolute -top-150-px -right-100 left-auto opacity-80 text-55"></i>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-16 bg-gray-300 relative pt-32">
        <div
          className="-mt-20 top-0 bottom-auto left-0 right-0 w-full absolute h-20"
          style={{ transform: "translateZ(0)" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-gray-300 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>

        <div className="container mx-auto">
          <div className="flex flex-wrap justify-center bg-white shadow-xl rounded-lg -mt-64 py-16 px-12 relative z-10">
            <div className="w-full text-center lg:w-8/12">
              <p className="text-4xl text-center">
                <span role="img" aria-label="love">
                  😍
                </span>
              </p>
              <h3 className="font-semibold text-3xl">
                {t('landing-did-you-like-H2OMonitor')}
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed mt-4 mb-4">
                {t('landing-did-you-like-H2OMonitor-p')}
              </p>
              <div className="sm:block flex flex-col mt-10">
                <a
                  onClick={() => void (Tawk_API.maximize())}
                  className="get-started cursor-pointer text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-2 bg-blue-500 active:bg-blue-600  text-sm shadow hover:shadow-lg ease-linear transition-all duration-150"
                >
                  <i className="fas fa-mug-hot text-lg mr-1"></i>
                  {t('contact-us')}
                </a>
                <Link
                  to="/admin/dashboard"
                  className="github-star sm:ml-1 text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-gray-800 active:bg-gray-700  text-sm shadow hover:shadow-lg"
                >
                  <i className="fas fa-desktop text-lg mr-2"></i>
                  {t('dashboard')}
                </Link>
              </div>
              <div className="text-center mt-16"></div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
